import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/select/page',
    method: 'post',
    data
  })
}

export const fetchSpecialCoalDashboard = (data) => {
  return request({
    url: '/api/produce/kanban/special-coal-transport-monitoring',
    method: 'post',
    data
  })
}

export const fetchCustomerOptions = (params) => {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get',
    params
  })
}

export const fetchCargoOptions = (params) => {
  return request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/produce/out-in-stock-record/select/id',
    method: 'get',
    params: {
      id
    }
  })
}
